/**
 * This file is used for JavaScript code to be run in the front-end
 * on posts/pages containing theslicpix  interactivity studio block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it is enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import './view.scss';

/* eslint-disable no-console */
const script = document.createElement( 'script' );
script.type = 'text/javascript';
script.src = 'https://interactivity.studio/js/wp-plugin-connectprimer.js';
script.setAttribute( 'data-is-id', 'wp-is-plugin-connectprimer' );
document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );

/* eslint-enable no-console */
